import React, { useState } from 'react'
import { Box, Button, Flex, FormControl, FormErrorMessage, FormLabel, Input, Select, Text } from '@chakra-ui/react';
import { Form, Formik } from 'formik';
import EventReportTable from '../components/EventReportTable';

function EventReport({ showColorStrip = true }) {
    const [toggleReport, setToggleReport] = useState(false);

    const initialValues = {
        eventType: '',
        examSchedule: '',
        membershipType: '',
        paymentStatus: '',
    };

    const handleSubmit = async (values) => {
        setToggleReport(!toggleReport)
    }
    return (
        <>
         <Box display="inline-block">
                  <Text color="#D11A2A" mb={1} fontSize={'18px'} fontWeight={700} mt={5}>
                    EVENT REPORT
                  </Text>
                  <Box
                    borderTop="10px solid transparent"
                    borderRadius="8px"
                    sx={{
                      borderImage: showColorStrip
                        ? "linear-gradient(to right, #E53E3E, #812773, #E53E3E)"
                        : "none",
                      borderImageSlice: showColorStrip ? 1 : 0,
                    }}
                  />
                </Box>
            <Box bgColor={'white'} height={["850px", "", '370px']} px={'30px'} py={'20px'} mb={5}>
                <Text color={'#3A3541DE'} fontSize={'16px'} fontWeight={500}>Search Filters</Text>
                <Formik
                    enableReinitialize
                    initialValues={initialValues}
                    // validationSchema={approvalReportSchema}
                    onSubmit={(values) => handleSubmit(values)}
                >
                    {({
                        errors, touched, values, handleBlur, handleChange
                    }) => (

                        <Form>
                            <Flex flexDirection={["column", "column", "row"]} alignItems={"center"} gap={3}>
                                <FormControl mt={4} isInvalid={errors.eventType && touched.eventType} color="#121212">
                                    <FormLabel htmlFor='eventType' fontSize={'16px'}>Event Type</FormLabel>
                                    <Select
                                        height={'52px'}
                                        name="eventType"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        bg={'#F3F3F3'}
                                        borderRadius={"0"}
                                        focusBorderColor="#ffffff"
                                        borderColor={"#FFFFFF"}
                                        _hover={{ borderColor: "#FFFFFF" }}
                                        _placeholder={{ color: "#B4B1B1" }}
                                        value={values?.eventType}
                                    >
                                        <option value='2020'>2020</option>
                                        <option value='2021'>2021</option>
                                    </Select>
                                    {touched.eventType && errors.eventType && (
                                        <FormErrorMessage>{errors.eventType}</FormErrorMessage>
                                    )}
                                </FormControl>
                                <FormControl mt={4} isInvalid={errors.eventSchedule && touched.eventSchedule} color="#121212">
                                    <FormLabel htmlFor='eventSchedule' fontSize={'16px'}>Event Schedule</FormLabel>
                                    <Select
                                        height={'52px'}
                                        name="eventSchedule"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        bg={'#F3F3F3'}
                                        borderRadius={"0"}
                                        focusBorderColor="#ffffff"
                                        borderColor={"#FFFFFF"}
                                        _hover={{ borderColor: "#FFFFFF" }}
                                        _placeholder={{ color: "#B4B1B1" }}
                                        value={values?.examDiet}
                                    >
                                        <option value='active'>active</option>
                                        <option value='inactive'>inactive</option>
                                    </Select>
                                    {touched.eventSchedule && errors.eventSchedule && (
                                        <FormErrorMessage>{errors.eventSchedule}</FormErrorMessage>
                                    )}
                                </FormControl>
                                <FormControl mt={4} isInvalid={errors.membershipType && touched.membershipType} color="#121212">
                                    <FormLabel htmlFor='membershipType' fontSize={'16px'}>Membership Type</FormLabel>
                                    <Select
                                        height={'52px'}
                                        name="membershipType"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        bg={'#F3F3F3'}
                                        borderRadius={"0"}
                                        focusBorderColor="#ffffff"
                                        borderColor={"#FFFFFF"}
                                        _hover={{ borderColor: "#FFFFFF" }}
                                        _placeholder={{ color: "#B4B1B1" }}
                                        value={values?.membershipType}
                                    >
                                        <option value='active'>active</option>
                                        <option value='inactive'>inactive</option>
                                    </Select>
                                    {touched.membershipType && errors.membershipType && (
                                        <FormErrorMessage>{errors.membershipType}</FormErrorMessage>
                                    )}
                                </FormControl>
                            </Flex>
                            <Flex flexDirection={["column", "column", "row"]} alignItems={"center"} gap={3}>
                                <FormControl mt={4} isInvalid={errors.paymentStatus && touched.paymentStatus} color="#121212">
                                    <FormLabel htmlFor='paymentStatus' fontSize={'16px'}>Payment Status</FormLabel>
                                    <Select
                                        height={'52px'}
                                        name="paymentStatus"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        bg={'#F3F3F3'}
                                        borderRadius={"0"}
                                        focusBorderColor="#ffffff"
                                        borderColor={"#FFFFFF"}
                                        _hover={{ borderColor: "#FFFFFF" }}
                                        _placeholder={{ color: "#B4B1B1" }}
                                        value={values?.paymentStatus}
                                    >
                                        <option value='1'>1</option>
                                        <option value='2'>2</option>
                                    </Select>
                                    {touched.paymentStatus && errors.paymentStatus && (
                                        <FormErrorMessage>{errors.paymentStatus}</FormErrorMessage>
                                    )}
                                </FormControl>
                                <FormControl mt={4} isInvalid={errors.startDate && touched.startDate}
                                    color="#121212" fontFamily={'inter'}>
                                    <FormLabel htmlFor='startDate' fontSize={"16px"}>Start Date</FormLabel>
                                    <Input
                                        height={'52px'}
                                        type="date"
                                        placeholder="Pick a Date"
                                        borderRadius={"0"}
                                        fontSize={"small"}
                                        bg={'#F3F3F3'}
                                        name="startDate"
                                        focusBorderColor="#ffffff"
                                        borderColor={"#FFFFFF"}
                                        _hover={{ borderColor: "#FFFFFF" }}
                                        _placeholder={{ color: "#B4B1B1" }}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values?.startDate}
                                    />
                                    {touched.startDate && errors.startDate && (
                                        <FormErrorMessage>{errors.startDate}</FormErrorMessage>
                                    )}
                                </FormControl>
                                <FormControl mt={4} isInvalid={errors.endDate && touched.endDate}
                                    color="#121212" fontFamily={'inter'}>
                                    <FormLabel htmlFor='endDate' fontSize={"16px"}>End Date</FormLabel>
                                    <Input
                                        height={'52px'}
                                        type="date"
                                        placeholder="Pick a Date"
                                        borderRadius={"0"}
                                        fontSize={"small"}
                                        bg={'#F3F3F3'}
                                        name="endDate"
                                        cursor={"pointer"}
                                        focusBorderColor="#ffffff"
                                        borderColor={"#FFFFFF"}
                                        _hover={{ borderColor: "#FFFFFF" }}
                                        _placeholder={{ color: "#B4B1B1" }}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values?.endDate}
                                    />
                                    {touched.endDate && errors.endDate && (
                                        <FormErrorMessage>{errors.endDate}</FormErrorMessage>
                                    )}
                                </FormControl>
                            </Flex>
                            <Flex justifyContent={'flex-end'} alignItems={'center'}>
                                <Button
                                    mt={10} fontSize={'14px'} fontWeight={'500'} lineHeight={'16px'}
                                    width={"118px"}
                                    background={"#D11A2A"}
                                    _hover={{ background: " " }}
                                    color={"#FFFFFF"}
                                    type="submit"
                                // isLoading={loading}
                                // loadingText="Saving ..."
                                >
                                    Fetch Report
                                </Button>
                            </Flex>
                        </Form>
                    )}
                </Formik>
            </Box>
            {
                toggleReport ? (<EventReportTable />) : null
            }
        </>
    )
}

export default EventReport